import { render, staticRenderFns } from "./UnitSizeEstimateIndicatorWrapper.vue?vue&type=template&id=d9aa78ea&"
import script from "./UnitSizeEstimateIndicatorWrapper.vue?vue&type=script&lang=js&"
export * from "./UnitSizeEstimateIndicatorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports